const firebaseConfig = {
    apiKey: "AIzaSyB8y2V3aiy8i7A01DemTQpAB_peY4rNq0A",
    authDomain: "gadget-care.firebaseapp.com",
    projectId: "gadget-care",
    storageBucket: "gadget-care.appspot.com",
    messagingSenderId: "385813355299",
    appId: "1:385813355299:web:a2e5537e3513e6e8a78a96"
};

export default firebaseConfig;